import React from 'react';
import OrderListTable from "../../../components/OrderListTable";
import {ShippingStatus} from "../../../../types/order";

export const CancelAllOrderPage = () => {
  return <OrderListTable status={ShippingStatus.CANCEL}/>;
};
